import React, { useEffect, useMemo } from "react";
import { StyleObject } from "styletron-react";
import { colors, fonts, frames, icons } from "../../Styles";
import { CoreNavLink } from "../../Components";
import { NavLinkTypes } from "../../Definitions";
import { useAppSelector } from "../../Store";
import { Graph_QL, useSystem } from "../../Services";
import { random } from "lodash";
import { SystemMenu_Pages, focus_viewMenu_Pages } from "../pages";

interface SystemMenu_Props {
  focus_view?: boolean;
  overrides?: {
    gridArea?: string;
  };
}

export default function SystemMenu({ focus_view, overrides }: SystemMenu_Props) {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getSystemsInfo, data: systemsState } = useSystem(connection);

  useEffect(() => {
    getSystemsInfo({}, connection);
  }, [connection]);

  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
      {} as StyleObject,
      overrides && overrides.gridArea ? { gridArea: overrides.gridArea } : {}
    );
  }, [overrides]);

  // TODO: Fjern Weaner Unit og Sow Unit når systemtype 2 og 3 eksisterer i db
  const systems = useMemo(() => {
    const original = (systemsState && systemsState[domain]?.data) || [];
  
    const manualSystems = [
      { name: "Weaner Unit", system_id: 3, fk_system_types: 3 },
      { name: "Sow Unit", system_id: 2, fk_system_types: 2 }
    ];
  
    return [/*...manualSystems, */ ...original];
  }, [domain, systemsState]);

  const systemTypeToLabel: Record<number, string> = {
    1: "Freeda Location Feeder",
    3: "AutoPig",
    2: "Freeda ESF Walk Through"
  };
  
  const systemTypeToIcon: Record<number, string> = {
    1: icons.freedaLF,
    3: icons.autoPig,
    2: icons.freedaESF_WalkThrough
  };
  
  const systemTypeToPage: Record<number, SystemMenu_Pages | focus_viewMenu_Pages> = {
    1: focus_view === true ? focus_viewMenu_Pages.op_freeda_lf : SystemMenu_Pages.freeda_lf,
    3: SystemMenu_Pages.autopig,
    2: SystemMenu_Pages.freeda_esf
  };

  return (
    <frames.SystemMenu $style={_Root}>
      {!systems ? ( <p style={{...fonts.fontsize4, ...fonts.paragraph, color: colors.greyLightTertiary, textAlign: "center"}}>No Systems Found</p> ) : ( // TODO Translate
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: focus_view ? "end" : "start", gap: "5px", width: "100%", height: "100%" }}> 
          {systems.map(system => {
            const page = systemTypeToPage[system?.fk_system_types];
            const systemId = system.system_id;
            const systemName = system.name;
            const iconSrc = systemTypeToIcon[system.fk_system_types];
            const toPath = `/${page}/${systemId}`;

            return (
              <CoreNavLink
                key={"page_"+systemId+random(0, 9999)}
                content={systemName}
                subContent={systemTypeToLabel[system.fk_system_types]}
                navLinkType={NavLinkTypes.systemNavLink}
                path={toPath}
                endPath={false}
                icon={iconSrc}
                focus_view={focus_view ?? false}
                overrides={{
                }}
              />
            );
          })}
        </div>
      )}
    </frames.SystemMenu>
  );
}